import React from "react"
import { useHistory } from "react-router-dom"
import FeatureCatalogTable, { IFeatureCatalog } from "./Components/FeatureCatalogTable"
import Overview from "./Components/Overview"
import FeatureCatalogProvider from "./FeatureCatalogProvider"

const FeatureCatalogViewer = () => {
  const history = useHistory()
  const pathname = history.location.pathname

  const detectClickedElement = (data: IFeatureCatalog) => {
    const address = `/featurecatalogdetails/${data.id}`
    history.push({ pathname: address, state: data.id })
  }

  if (pathname.endsWith("featurecatalogdetails/") || pathname.endsWith("featurecatalogdetails")) {
    return <FeatureCatalogTable onClick={detectClickedElement} />
  } else {
    return (
      <FeatureCatalogProvider>
        <Overview />
      </FeatureCatalogProvider>
    )
  }
}

export default FeatureCatalogViewer
